import React from "react";
import { apiPost } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";
import OInputField from "components/reusable/OInputField";
import { numericInputPattern, preventMaxInput } from "utils/validations";
import formValidation from "../../utils/formValidation";

const CountryAdd = ({ allCountry, handleCategory }) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      countryCode: "+",
    },
  });
  const handleSubmitForm1 = async (data) => {
    try {
      const payload = {
        name: data?.name?.trim(),
        countryCode: data?.countryCode.slice(1),
      };
      const res = await apiPost(apiPath.countryAdd, payload);
      if (res?.data?.success) {
        allCountry();
        handleCategory(false);
        notification.success(res.data?.message);
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.log("err:", err);
    }
  };

  const handleDecimalOffer = (e) => {
    var value = e.target.value;
    setValue("countryCode", "+" + value.slice(1));
  };

  return (
    <>
      <div className="overflow-x-hidden overflow-y-auto fixed inset-0 justify-center items-center flex z-50 outline-none focus:outline-none">
        <div className="relative mx-auto max-w-3xl w-auto my-6">
          <div className="sm:px-2 sm:py-8 px-7 md:py-4">
            <div className="border-0 rounded-lg flex-col w-full bg-white shadow-lg relative flex outline-none focus:outline-none min-w-[750px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("ADD_COUNTRY")}</h3>
                <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none">
                  <span
                    title="Close"
                    className=" text-[#B8BBBF] text-4xl"
                    onClick={() => handleCategory(false)}
                  >
                    ×
                  </span>
                </button>
              </div>
              <form method="post" onSubmit={handleSubmit(handleSubmitForm1)}>
                <div className="flex-auto relative p-6">
                  <div className="grid sm:grid-cols-2">
                    <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                      <div className="relative z-0 w-full group">
                      <OInputField
                          name='countryCode'
                          id='countryCode'
                          autoFocus={true}
                          wrapperClassName='relative z-0 w-full group'
                          type='text'
                          errors={errors}
                          inputLabel={
                            <>
                              {t('COUNTRY_CODE')}
                              <span className='text-red-500'>*</span>
                            </>
                          }
                          onKeyDown={event => numericInputPattern(event)}
                          placeholder=''
                          maxLength={4}
                          onInput={e => preventMaxInput(e, 4)}
                          register={register('countryCode', {
                            required: 'Please enter country code.',
                            min: {
                              value: 1,
                              message: 'Minimum value must is 1.'
                            },
                            onChange: e => handleDecimalOffer(e)
                          })}
                        />
                      </div>
                    </div>
                    <div className="md:py-4 px-7 sm:px-2 sm:py-8">
                      <div className="relative z-0 w-full group">
                        <OInputField
                          name="name"
                          id="name"
                          wrapperClassName="relative w-full z-0  group"
                          type="text"
                          inputLabel={
                            <>
                              {t("COUNTRY")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          placeholder=""
                          onInput={(e) => preventMaxInput(e, 30)}
                          maxLength={30}
                          register={register(
                            "name",
                            formValidation["countryName"]
                          )}
                          errors={errors}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/*footer*/}
                <div className="border-t border-solid flex items-center justify-center p-6 border-slate-200 rounded-b">
                  <button
                    type="button"
                    onClick={() => handleCategory(false)}
                    className="font-normal px-12 py-2.5 text-black bg-[#E1E1E1] text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                  >
                    {t("O_BACK")}
                  </button>

                  <button
                    type="submit"
                    className="rounded shadow hover:shadow-lg outline-none bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 focus:outline-none mr-1  ease-linear transition-all duration-150"
                  >
                    {t("O_ADD")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default CountryAdd;
